import { useState, useEffect } from "react";
import axios from "axios"
import { useNavigate } from "react-router-dom";


const StarIcon = () => (
  <svg className="w-4 h-4 text-amber-400 fill-amber-400" viewBox="0 0 24 24">
    <path d="M12.854 3.501a.97.97 0 0 0-1.708 0C9.946 5.782 9.495 7.002 9.089 8.262a1.03 1.03 0 0 1-.977.743C6.952 9.035 5.84 9.126 4.738 9.282c-.778.135-1.069 1.018-.516 1.556C5.627 12.254 6.629 13.098 7.694 13.878a1.03 1.03 0 0 1 .378 1.152c-.44 1.32-.78 2.683-1.012 4.082-.047.28-.089.562-.127.845-.1.754.709 1.287 1.41.927C9.585 19.868 10.666 19.174 11.692 18.413a.97.97 0 0 1 1.156 0c1.026.761 2.107 1.455 3.221 2.076.7.36 1.51-.173 1.41-.927a19.7 19.7 0 0 0-.127-.845c-.232-1.4-.572-2.762-1.012-4.082a1.03 1.03 0 0 1 .378-1.152c1.065-.78 2.067-1.624 2.972-2.512.625-.562.334-1.445-.44-1.58a19.9 19.9 0 0 0-1.261-.148c-1.102-.156-2.214-.247-3.328-.277a1.03 1.03 0 0 1-.976-.742C14.505 7.002 14.054 5.782 12.854 3.501Z"/>
  </svg>
);

const ClockIcon = () => (
  <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth={1.5} viewBox="0 0 24 24">
    <circle cx="12" cy="12" r="9" /><path d="M12 6v6l4 2" />
  </svg>
);

const UsersIcon = () => (
  <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth={1.5} viewBox="0 0 24 24">
    <path d="M17 19.5C17 17.843 14.761 16.5 12 16.5 9.239 16.5 7 17.843 7 19.5M21 16.5c0-1.23-1.234-2.287-3-2.75M3 16.5c0-1.23 1.234-2.287 3-2.75M18 9.736A3.5 3.5 0 0 0 16 4.5a3.5 3.5 0 0 0-2 .764M6 9.736A3.5 3.5 0 0 1 8 4.5a3.5 3.5 0 0 1 2 .764M12 13.5a3 3 0 1 1 0-6 3 3 0 0 1 0 6Z" />
  </svg>
);

const MapIcon = () => (
  <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth={1.5} viewBox="0 0 24 24">
    <path d="M3 8.593c0-1.527 0-2.29.393-2.736a1.4 1.4 0 0 1 .497-.302C5.306 4.833 7.162 6.552 8.659 6.499a5 5 0 0 0 .588-.082c2.184-.535 3.551-3.08 5.798-3.391 1.287-.179 2.7.598 3.904 1.014.99.342 1.485.513 1.768.92C21 5.368 21 5.909 21 6.99v8.422c0 1.527 0 2.29-.393 2.736a1.4 1.4 0 0 1-.497.302c-1.416.653-3.272-1.065-4.769-1.012a5 5 0 0 0-.588.082c-2.184.535-3.551 3.08-5.798 3.391C7.674 21.156 4.108 20.229 3.283 19.043 3 18.636 3 18.096 3 17.014V8.593Z" />
    <path d="M9 6.541v14.255M15 3.181v14.255" />
  </svg>
);

const HeartIcon = ({ filled }) => (
  <svg className={`w-5 h-5 ${filled ? "fill-rose-500 stroke-rose-500" : "stroke-gray-400"}`} fill="none" strokeWidth={1.5} viewBox="0 0 24 24">
    <path d="M7.75 3.5C5.127 3.5 3 5.76 3 8.547 3 14.125 12 20.5 12 20.5S21 14.125 21 8.547C21 5.094 18.873 3.5 16.25 3.5c-1.86 0-3.47 1.136-4.25 2.79C11.22 4.637 9.61 3.5 7.75 3.5Z" />
  </svg>
);

const ChevronDown = () => (
  <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth={1.5} viewBox="0 0 24 24">
    <path d="M6 9l6 6 6-6" />
  </svg>
);

const FilterIcon = () => (
  <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth={1.5} viewBox="0 0 24 24">
    <path d="M4.5 7h15M7 12h10M10 17h4" />
  </svg>
);

function StarRating({ rating, reviews }) {
  if (reviews === 0) return <span className="text-sm text-gray-400">No reviews yet</span>;
  return (
    <div className="flex items-center gap-1">
      <StarIcon />
      <span className="text-sm font-semibold text-gray-800">{rating}</span>
      <span className="text-sm text-gray-500">({reviews})</span>
    </div>
  );
}

function FilterSection({ title, items, selected, onToggle, showMoreLimit = 5 }) {
  const [expanded, setExpanded] = useState(false);
  const visible = expanded ? items : items.slice(0, showMoreLimit);

  
  return (
    <div className="border-b border-gray-100 pb-4 mb-4">
      <h4 className="font-semibold text-gray-800 text-sm mb-3">{title}</h4>
      <div className="space-y-2">
        {visible.map((item) => (
          <label key={item} className="flex items-center gap-2 cursor-pointer group">
            <div
  onClick={() => onToggle(item)}
  className={`w-5 h-5 rounded border-2 flex items-center justify-center flex-shrink-0 transition-colors ${
    selected === item
      ? "bg-[#FD5200] border-[#FD5200]"
      : "border-gray-300 group-hover:border-[#FD5200]"
  }`}
>
  {selected === item && (
    <svg
      className="w-3 h-3 text-white"
      fill="none"
      stroke="currentColor"
      strokeWidth={2.5}
      viewBox="0 0 24 24"
    >
      <path d="M5 13l4 4L19 7" />
    </svg>
  )}
</div>
            <span className="text-sm text-gray-600 group-hover:text-gray-900">{item}</span>
          </label>
        ))}
      </div>
      {items.length > showMoreLimit && (
        <button
          onClick={() => setExpanded(!expanded)}
          className="mt-2 text-sm text-[#FD5200] hover:text-[#e54a00] flex items-center gap-1 font-medium"
        >
          {expanded ? "Show less" : "Show more"}
          <ChevronDown />
        </button>
      )}
    </div>
  );
}

function PriceRangeSlider({ min, max, value, onChange }) {
  return (
    <div className="border-b border-gray-100 pb-4 mb-4">
      <h4 className="font-semibold text-gray-800 text-sm mb-3">Price range</h4>
      <div className="space-y-3">
        <input
          type="range"
          min={min}
          max={max}
          value={value}
          onChange={(e) => onChange(Number(e.target.value))}
          className="w-full accent-[#FD5200]"
        />
        <div className="flex justify-between text-sm text-gray-600">
          <span>Min: ₹{min}</span>
<span>Max: ₹{value}</span>
        </div>
      </div>
    </div>
  );
}

function TourCard({ tour }) {
  const [wishlisted, setWishlisted] = useState(false);

  const navigate = useNavigate()

     useEffect(() => {
      window.scrollTo(0, 0);
    }, []);

  return (
    <div onClick={() => navigate(`/tour-details/${tour?._id}`)} className="bg-white rounded-2xl border border-gray-100 shadow-sm hover:shadow-md transition-shadow duration-200 overflow-hidden flex flex-col sm:flex-row">
      {/* Image */}
      <div className="relative sm:w-72 lg:w-80  flex-shrink-0">
        <img
          src={tour?.images?.[0]}
          alt={tour?.name}
          className="w-full h-56 md:h-64 object-cover"
        />
        <button
          onClick={() => setWishlisted(!wishlisted)}
          className="absolute top-3 right-3 bg-white/90 backdrop-blur-sm rounded-full p-2 shadow hover:scale-110 transition-transform"
        >
          <HeartIcon filled={wishlisted} />
        </button>
      </div>

      {/* Content */}
      <div className="flex flex-col flex-1 p-5">
        {/* Top */}
        <div className="flex-1">
          <div className="flex items-center justify-between flex-wrap gap-2 mb-2">
            <StarRating rating={tour?.review} reviews={tour?.rating} />
            <span className="text-xs font-medium text-[#FD5200] bg-[#FFFAF5] px-2.5 py-1 rounded-full">
              📍 {tour?.location}
            </span>
          </div>

          <h3 className="font-bold text-gray-900 text-lg leading-snug mb-3 hover:text-[#FD5200] cursor-pointer transition-colors">
            {tour?.name}
          </h3>

          <div className="flex items-center gap-4 mb-3 text-gray-500 flex-wrap">
            <div className="flex items-center gap-1.5 text-sm">
              <ClockIcon />
              <span>{tour?.overview?.duration}</span>
            </div>
            <div className="flex items-center gap-1.5 text-sm">
              <UsersIcon />
              <span>{tour?.overview?.travelers}</span>
            </div>
          </div>

          <p className="text-sm text-gray-500 leading-relaxed line-clamp-2">{tour?.description}</p>
        </div>

        {/* Bottom */}
        <div className="flex items-center justify-between pt-4 mt-4 border-t border-gray-50 flex-wrap gap-3">
          <div>
            <span className="text-xs text-gray-400">from </span>
            <span className="text-2xl font-bold text-gray-900">₹{tour?.offerPrice}</span>
            <span className="text-xs text-gray-400"> /Person{tour.priceType}</span>
          </div>
          <div className="flex items-center gap-2">
            {tour.hasMap && (
              <button className="flex items-center gap-1.5 px-3 py-2 rounded-lg border border-gray-200 text-sm text-gray-600 hover:bg-gray-50 hover:border-gray-300 transition-colors font-medium">
                <MapIcon />
                <span>View maps</span>
              </button>
            )}
            <button onClick={() => navigate(`/tour-details/${tour?._id}`)} className="px-5 py-2 bg-[#FD5200] hover:bg-white text-white hover:text-[#FD5200] border border-[#FD5200] text-sm font-semibold rounded-lg transition-colors">
              View tour
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default function TourList() {
  const [filterOpen, setFilterOpen] = useState(false);
  const [maxPrice, setMaxPrice] = useState(0);
  const [selectedTypes, setSelectedTypes] = useState("");
  const [tourData, setTourData] = useState([])
   const [page, setPage] = useState(1);

  const [totalPages, setTotalPages] = useState(1);

  const prices = tourData.map((tour) => tour.offerPrice);

const minPrice = prices.length ? Math.min(...prices) : 1000;
const maxPriceLimit = prices.length ? Math.max(...prices) : 10000;

  const [tourType, setTourType] = useState([])

  const fetchToursData = async (currentPage = 1) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/tour-details/get-all?page=${currentPage}&limit=8`,
      );
  const tours = response?.data?.tours || [];
    setTourData(tours);
    setTotalPages(response?.data?.pagination?.totalPages);
      setPage(currentPage);

    if (tours.length > 0) {
      const prices = tours.map((tour) => tour.offerPrice);
      const max = Math.max(...prices);
      setMaxPrice(max);
    }
      
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchToursData();
  }, []);

  useEffect(() => {
      window.scrollTo(0, 0);
    }, []);

   const fetchToursTypeData = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/tour-types/get-all`,
        );
        setTourType(response.data);
      } catch (error) {
        console.error(error);
      }
    };
  
    useEffect(() => {
      fetchToursTypeData();
   }, []);

  const filteredTours = tourData.filter((tour) => {
  const matchType =
    !selectedTypes || tour?.tourType?.name === selectedTypes;

  const matchPrice = tour?.offerPrice <= maxPrice;

  return matchType && matchPrice;
});


 const toggleType = (item) => {
  setSelectedTypes(item);
};

  const clearFilters = () => {
    setMaxPrice(300);
    setSelectedTypes("");
    
  };

  return (
    <div className="">
            <div className="relative h-[400px] overflow-hidden">
        <img
          src="https://i.ytimg.com/vi/Ars7ksBECX4/maxresdefault.jpg"
          alt="Banner"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 " />
        <div className="absolute inset-0 flex flex-col items-center justify-center">
          {/* <h1 className="text-3xl md:text-4xl font-black tracking-tight text-white drop-shadow-lg">Car Details</h1> */}
          {/* <div className="flex items-center gap-2 mt-2 text-slate-300 text-sm">
            <span>🏠</span>
            <span className="text-slate-400">›</span>
            <span>Tour</span>
            <span className="text-slate-400">›</span>
            <span className="text-amber-400 font-medium">Tour Lists</span>
          </div> */}
        </div>
      </div>

      <div className="w-full mx-auto px-4 sm:px-8 lg:px-20 py-10">
        {/* Header Bar */}
        <div className="flex flex-wrap items-center justify-between gap-3 mb-6">
          <div className="flex items-center gap-3 flex-wrap">
            <button
              onClick={() => setFilterOpen(!filterOpen)}
              className="flex items-center gap-2 px-4 py-2.5 bg-white border border-gray-200 rounded-lg text-sm font-medium text-gray-700 hover:bg-gray-50 shadow-sm transition-colors"
            >
              <FilterIcon />
              Filter
            </button>
            <span className="text-sm text-gray-600 font-medium">{filteredTours.length}</span>
            <button
              onClick={clearFilters}
              className="text-sm text-[#FD5200] hover:text-[#e54a00] font-medium underline underline-offset-2"
            >
              Clear filter
            </button>
          </div>

          {/* Sort */}
          
        </div>

        <div className="flex gap-6">
          {/* Sidebar Filter */}
          <aside
            className={`flex-shrink-0 w-64 xl:w-72 bg-white rounded-2xl border border-gray-100 shadow-sm p-5 self-start sticky top-4 transition-all duration-200 ${
              filterOpen ? "block" : "hidden lg:block"
            }`}
          >
            <h3 className="font-bold text-gray-900 text-base mb-5">Filters</h3>

            <PriceRangeSlider min={minPrice} max={maxPriceLimit} value={maxPrice} onChange={setMaxPrice} />

            <FilterSection
              title="Types"
              items={tourType.map((t) => t.name)}
              selected={selectedTypes}
              onToggle={toggleType}
            />
           
            <button
              onClick={clearFilters}
              className="w-full mt-2 py-2.5 border border-gray-200 rounded-lg text-sm font-medium text-gray-600 hover:bg-gray-50 transition-colors"
            >
              Clear all filters
            </button>
          </aside>

          {/* Mobile Filter Overlay */}
          {filterOpen && (
            <div
              className="fixed inset-0 bg-black/40 z-30 lg:hidden"
              onClick={() => setFilterOpen(false)}
            />
          )}

          {/* Mobile Filter Drawer */}
          <div
            className={`fixed left-0 top-0 h-full w-72 bg-white z-40 shadow-2xl p-5 overflow-y-auto transition-transform duration-300 lg:hidden ${
              filterOpen ? "translate-x-0" : "-translate-x-full"
            }`}
          >
            <div className="flex items-center justify-between mb-5">
              <h3 className="font-bold text-gray-900 text-base">Filters</h3>
              <button onClick={() => setFilterOpen(false)} className="text-gray-400 hover:text-gray-600 text-xl font-bold">✕</button>
            </div>
            <PriceRangeSlider min={minPrice} max={maxPriceLimit} value={maxPrice} onChange={setMaxPrice} />
            <FilterSection title="Types" items={tourType?.map((t) => t.name)} selected={selectedTypes} onToggle={toggleType} />
            <button onClick={clearFilters} className="w-full mt-2 py-2.5 border border-gray-200 rounded-lg text-sm font-medium text-gray-600 hover:bg-gray-50 transition-colors">
              Clear all filters
            </button>
          </div>

          {/* Tour List */}
          <div className="flex-1 min-w-0">
            <div className="space-y-4">
              {filteredTours.map((tour) => (
                <TourCard key={tour?._id} tour={tour} />
              ))}
            </div>

            {/* Pagination */}
            <div className="flex items-center justify-between mt-8">
              <div className="mt-6 flex items-center justify-center gap-2">
          <button
            disabled={page === 1}
            onClick={() => fetchToursData(page - 1)}
            className="rounded border px-3 py-1 disabled:opacity-50"
          >
            Prev
          </button>

          {Array.from({ length: totalPages }, (_, index) => (
            <button
              key={index}
              onClick={() => fetchToursData(index + 1)}
              className={`rounded border px-3 py-1 ${
                page === index + 1 ? "bg-red-500 text-white" : ""
              }`}
            >
              {index + 1}
            </button>
          ))}

          <button
            disabled={page === totalPages}
            onClick={() => fetchToursData(page + 1)}
            className="rounded border px-3 py-1 disabled:opacity-50"
          >
            Next
          </button>
        </div>
      </div>
              
            </div>
          </div>
        </div>
      </div>
    
  );
}